import { t } from '../i18n/uiText';

/** Те же user-строки, что кнопки под стихом в ChatStreamView. */
export function guestInsightUserMessage(mode) {
  if (mode === 'explain') return t('verseExplain');
  if (mode === 'simple') return t('chatFollowUpSimple');
  if (mode === 'application') return t('chatApplyLifePrompt');
  return '';
}

export function buildGuestInsightSnapshot(explainAnswerText) {
  const answer = String(explainAnswerText || '').trim();
  return {
    initialQuestion: t('verseExplain'),
    userTurns: [],
    assistantTurns: answer ? [answer] : [],
  };
}

/**
 * Snapshot для гостевого API: как verseOnlySnapshot / runFollowUp в чате.
 * Application без priorAnswer (ответ simple на главной) — без snapshot.
 */
export function guestInsightSnapshotForMode(mode, priorAnswerText) {
  if (mode === 'explain') return null;
  if (mode === 'simple') return buildGuestInsightSnapshot(priorAnswerText);
  if (mode === 'application') {
    const answer = String(priorAnswerText || '').trim();
    return answer ? buildGuestInsightSnapshot(priorAnswerText) : null;
  }
  return null;
}

export function guestInsightSnapshotFingerprint(snapshot) {
  const n = snapshot?.assistantTurns?.length ?? 0;
  return n > 0 ? `a${n}` : '0';
}
